import { Topic } from "src/data/topic/topic";

export const sortTopics = (a: Topic, b: Topic) => a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase() ? 1 : -1;